const imageConfig = {
  layout: 'constrained',
  backgroundColor: '#0878c8',
  images: {
    fallback: {
      src: '',
    },
  },
};

export default imageConfig;
